<template>
  <v-container fluid class="painel-chat-container pa-4 pa-md-6">
    <!-- Cabeçalho Principal -->
    <v-row class="mb-2">
      <v-col cols="12" class="d-flex flex-column flex-sm-row justify-space-between align-start align-sm-center">
        <div>
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-2" size="28">mdi-headset</v-icon>
            <h2 class="text-h5 font-weight-bold text--primary mb-0">Painel de Supervisão do Chat</h2>
          </div>
          <p class="text-body-2 grey--text text--darken-1 mb-0 mt-1">
            Acompanhamento operacional, indicadores de resolução e auditoria de divergências Sonax
          </p>
        </div>

        <div class="mt-3 mt-sm-0 d-flex align-center">
          <v-chip v-if="divergenciaConsultada" small color="amber lighten-4" text-color="amber darken-4" class="mr-2 font-weight-medium">
            <v-icon left small color="amber darken-4">mdi-sync-alert</v-icon>
            Divergências ativas
          </v-chip>
          <v-btn
            color="primary"
            class="elevation-1 font-weight-bold"
            height="40"
            :loading="carregando"
            @click="buscar"
          >
            <v-icon left>mdi-refresh</v-icon>
            Atualizar Dados
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <!-- Card de Filtros Inteligentes -->
    <v-card class="pa-4 mb-5 painel-card filter-card" elevation="0">
      <div class="d-flex align-center justify-space-between mb-3">
        <span class="text-subtitle-2 font-weight-bold text--primary d-flex align-center">
          <v-icon small color="primary" class="mr-1">mdi-filter-variant</v-icon>
          Filtros de Pesquisa
        </span>
        <div class="periodo-chips d-none d-md-flex align-center">
          <span class="text-caption grey--text mr-2">Períodos rápidos:</span>
          <v-chip
            v-for="periodo in periodosRapidos"
            :key="periodo.valor"
            x-small
            :outlined="periodoSelecionado !== periodo.valor"
            class="mr-1 font-weight-medium cursor-pointer"
            :color="periodoSelecionado === periodo.valor ? 'primary' : undefined"
            :text-color="periodoSelecionado === periodo.valor ? 'white' : undefined"
            @click="aplicarPeriodoRapido(periodo.valor)"
          >
            {{ periodo.texto }}
          </v-chip>
        </div>
      </div>

      <v-row dense>
        <!-- Data Inicial -->
        <v-col cols="12" sm="6" md="2">
          <label class="text-caption font-weight-bold grey--text text--darken-2">Data Inicial</label>
          <v-menu v-model="menuInicio" :close-on-content-click="false" offset-y min-width="290px">
            <template #activator="{ on }">
              <v-text-field
                :value="formatarData(dataInicio)"
                dense
                outlined
                readonly
                hide-details
                prepend-inner-icon="mdi-calendar"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="dataInicio"
              no-title
              locale="pt-br"
              @input="menuInicio = false; periodoSelecionado = null"
            />
          </v-menu>
        </v-col>

        <!-- Data Final -->
        <v-col cols="12" sm="6" md="2">
          <label class="text-caption font-weight-bold grey--text text--darken-2">Data Final</label>
          <v-menu v-model="menuFim" :close-on-content-click="false" offset-y min-width="290px">
            <template #activator="{ on }">
              <v-text-field
                :value="formatarData(dataFim)"
                dense
                outlined
                readonly
                hide-details
                prepend-inner-icon="mdi-calendar"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="dataFim"
              no-title
              locale="pt-br"
              @input="menuFim = false; periodoSelecionado = null"
            />
          </v-menu>
        </v-col>

        <!-- Empresa -->
        <v-col cols="12" sm="6" md="3">
          <label class="text-caption font-weight-bold grey--text text--darken-2">Empresa</label>
          <v-select
            v-model="empresa"
            :items="empresas"
            dense
            outlined
            hide-details
            prepend-inner-icon="mdi-office-building"
          />
        </v-col>

        <!-- Situação Local -->
        <v-col cols="12" sm="6" md="2">
          <label class="text-caption font-weight-bold grey--text text--darken-2">Situação Local</label>
          <v-select
            v-model="situacao"
            :items="situacoes"
            dense
            outlined
            hide-details
            prepend-inner-icon="mdi-list-status"
          />
        </v-col>

        <!-- Interação do Cliente -->
        <v-col cols="12" sm="6" md="3">
          <label class="text-caption font-weight-bold grey--text text--darken-2">Interação do Cliente</label>
          <v-select
            v-model="interacao"
            :items="opcoesInteracao"
            dense
            outlined
            hide-details
            prepend-inner-icon="mdi-account-switch"
          />
        </v-col>

        <!-- Protocolo Específico -->
        <v-col cols="12" sm="6" md="3" class="mt-2">
          <label class="text-caption font-weight-bold grey--text text--darken-2">Protocolo Específico</label>
          <v-text-field
            v-model="protocolo"
            dense
            outlined
            hide-details
            clearable
            placeholder="Número do protocolo..."
            prepend-inner-icon="mdi-pound"
            @keyup.enter="buscar"
          />
        </v-col>

        <!-- Checkbox: Consultar Divergência -->
        <v-col cols="12" sm="6" md="4" class="mt-2 d-flex align-center">
          <div class="d-flex align-center option-box pa-2 rounded">
            <v-checkbox
              v-model="consultarDivergencia"
              hide-details
              class="mt-0 pt-0"
              color="primary"
            >
              <template #label>
                <span class="text-body-2 font-weight-medium text--primary">Consultar divergência</span>
              </template>
            </v-checkbox>
            <v-tooltip top max-width="320">
              <template #activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  color="grey darken-1"
                  class="ml-2 help-icon"
                >
                  mdi-help-circle-outline
                </v-icon>
              </template>
              <span>esse campo será utilizado como consulta de divergencias entre a base do Portal e a Sonax Chat.</span>
            </v-tooltip>
          </div>
        </v-col>

        <!-- Checkbox: Ignorar Campanha -->
        <v-col cols="12" sm="6" md="5" class="mt-2 d-flex align-center">
          <div class="d-flex align-center option-box pa-2 rounded">
            <v-checkbox
              v-model="ignorarCampanha"
              hide-details
              class="mt-0 pt-0"
              color="primary"
            >
              <template #label>
                <span class="text-body-2 font-weight-medium text--primary">Ignorar campanha ou automações</span>
              </template>
            </v-checkbox>
            <v-tooltip top max-width="320">
              <template #activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  color="grey darken-1"
                  class="ml-2 help-icon"
                >
                  mdi-help-circle-outline
                </v-icon>
              </template>
              <span>ao marcar esse campo serão ignoradas todos os disparos a partir de templates de automação.</span>
            </v-tooltip>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <!-- Cards de Indicadores (KPIs) -->
    <v-row class="mb-4" dense>
      <!-- Total Geral -->
      <v-col cols="12" sm="6" md="3" lg="3">
        <v-card class="kpi-card pa-4 h-100 d-flex flex-column justify-space-between" elevation="0">
          <div class="d-flex align-center justify-space-between">
            <span class="text-caption font-weight-bold grey--text text--darken-1 text-uppercase">Total Protocolos</span>
            <v-avatar size="36" color="blue lighten-5">
              <v-icon color="blue darken-2" size="20">mdi-message-text-outline</v-icon>
            </v-avatar>
          </div>
          <div class="mt-2">
            <div class="text-h4 font-weight-bold text--primary">{{ totais.total }}</div>
            <div class="text-caption grey--text mt-1 d-flex align-center">
              <v-icon x-small color="grey" class="mr-1">mdi-calendar-range</v-icon>
              No período de {{ formatarData(dataInicio) }} a {{ formatarData(dataFim) }}
            </div>
          </div>
        </v-card>
      </v-col>

      <!-- Abertos -->
      <v-col cols="12" sm="6" md="3" lg="3">
        <v-card class="kpi-card pa-4 h-100 d-flex flex-column justify-space-between" elevation="0">
          <div class="d-flex align-center justify-space-between">
            <span class="text-caption font-weight-bold amber--text text--darken-3 text-uppercase">Em Aberto</span>
            <v-avatar size="36" color="amber lighten-5">
              <v-icon color="amber darken-3" size="20">mdi-progress-clock</v-icon>
            </v-avatar>
          </div>
          <div class="mt-2">
            <div class="text-h4 font-weight-bold amber--text text--darken-4">{{ totais.abertos }}</div>
            <div class="text-caption grey--text mt-1">
              <strong>{{ taxaAbertos }}%</strong> do volume total ativo
            </div>
          </div>
        </v-card>
      </v-col>

      <!-- Fechados -->
      <v-col cols="12" sm="6" md="3" lg="3">
        <v-card class="kpi-card pa-4 h-100 d-flex flex-column justify-space-between" elevation="0">
          <div class="d-flex align-center justify-space-between">
            <span class="text-caption font-weight-bold green--text text--darken-3 text-uppercase">Finalizados</span>
            <v-avatar size="36" color="green lighten-5">
              <v-icon color="green darken-2" size="20">mdi-check-circle-outline</v-icon>
            </v-avatar>
          </div>
          <div class="mt-2">
            <div class="text-h4 font-weight-bold green--text text--darken-3">{{ totais.fechados }}</div>
            <div class="text-caption grey--text mt-1">
              <strong>{{ taxaResolucao }}%</strong> taxa de resolução
            </div>
          </div>
        </v-card>
      </v-col>

      <!-- Divergências ou Taxa de Interação -->
      <v-col cols="12" sm="6" md="3" lg="3">
        <v-card
          class="kpi-card pa-4 h-100 d-flex flex-column justify-space-between"
          :class="{ 'divergencia-alerta': divergenciaConsultada && totais.divergencias > 0 }"
          elevation="0"
        >
          <div class="d-flex align-center justify-space-between">
            <span
              class="text-caption font-weight-bold text-uppercase"
              :class="divergenciaConsultada ? (totais.divergencias > 0 ? 'red--text text--darken-2' : 'green--text text--darken-2') : 'cyan--text text--darken-3'"
            >
              {{ divergenciaConsultada ? "Divergências" : "Com Interação" }}
            </span>
            <v-avatar
              size="36"
              :color="divergenciaConsultada ? (totais.divergencias > 0 ? 'red lighten-5' : 'green lighten-5') : 'cyan lighten-5'"
            >
              <v-icon
                :color="divergenciaConsultada ? (totais.divergencias > 0 ? 'red darken-2' : 'green darken-2') : 'cyan darken-3'"
                size="20"
              >
                {{ divergenciaConsultada ? (totais.divergencias > 0 ? 'mdi-alert-circle-outline' : 'mdi-check-all') : 'mdi-forum-outline' }}
              </v-icon>
            </v-avatar>
          </div>
          <div class="mt-2">
            <div
              class="text-h4 font-weight-bold"
              :class="divergenciaConsultada ? (totais.divergencias > 0 ? 'red--text text--darken-3' : 'green--text text--darken-3') : 'cyan--text text--darken-4'"
            >
              {{ divergenciaConsultada ? totais.divergencias : totais.comInteracao }}
            </div>
            <div class="text-caption grey--text mt-1">
              <span v-if="divergenciaConsultada">
                {{ totais.divergencias > 0 ? 'Necessitam sincronização' : 'Bases sincronizadas' }}
              </span>
              <span v-else>
                <strong>{{ taxaInteracao }}%</strong> responderam ao contato
              </span>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Banner de Ação em Lote para Divergências (Base Local) -->
    <v-card
      v-if="divergenciaConsultada && elegiveis.length > 0"
      class="pa-4 mb-5 painel-card divergencia-banner"
      elevation="0"
    >
      <v-row align="center" dense>
        <v-col cols="12" md="7" class="d-flex align-center">
          <v-avatar color="amber lighten-4" size="40" class="mr-3 flex-shrink-0">
            <v-icon color="amber darken-4">mdi-sync-alert</v-icon>
          </v-avatar>
          <div>
            <div class="text-subtitle-2 font-weight-bold amber--text text--darken-4">
              Divergências detectadas entre o Portal e a Sonax (Base Local)
            </div>
            <div class="text-caption grey--text text--darken-2">
              <strong>{{ divergentesFechadosSonax }}</strong> aberto(s) na base local e fechado(s) na Sonax ·
              <strong>{{ divergentesAbertosSonax }}</strong> fechado(s) na base local e aberto(s) na Sonax
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="5" class="d-flex justify-end align-center flex-wrap mt-2 mt-md-0">
          <v-btn
            outlined
            small
            class="mr-2 text-capitalize font-weight-medium"
            :disabled="elegiveis.length === 0"
            @click="alternarTodos(!todosSelecionados)"
          >
            <v-icon left small>{{ todosSelecionados ? 'mdi-checkbox-blank-outline' : 'mdi-checkbox-marked-outline' }}</v-icon>
            {{ todosSelecionados ? "Desmarcar todos" : `Selecionar elegíveis (${elegiveis.length})` }}
          </v-btn>

          <v-btn
            color="error"
            small
            class="elevation-1 text-capitalize font-weight-bold"
            :disabled="selecionados.length === 0"
            :loading="fechando"
            @click="fecharSelecionados"
          >
            <v-icon left small>mdi-lock-check</v-icon>
            Fechar selecionados na base ({{ selecionados.length }})
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <!-- Banner de Ação em Lote para Divergências (Base Sonax) -->
    <v-card
      v-if="divergenciaConsultada && elegiveisSonax.length > 0"
      class="pa-4 mb-5 painel-card divergencia-sonax-banner"
      elevation="0"
    >
      <v-row align="center" dense>
        <v-col cols="12" md="7" class="d-flex align-center">
          <v-avatar color="deep-purple lighten-4" size="40" class="mr-3 flex-shrink-0">
            <v-icon color="deep-purple darken-4">mdi-cloud-sync-outline</v-icon>
          </v-avatar>
          <div>
            <div class="text-subtitle-2 font-weight-bold deep-purple--text text--darken-4">
              Divergências detectadas na base da Sonax (Fechado Local · Aberto Sonax)
            </div>
            <div class="text-caption grey--text text--darken-2">
              <strong>{{ divergentesAbertosSonax }}</strong> fechado(s) na base local e aberto(s) na Sonax ·
              <strong>{{ divergentesFechadosSonax }}</strong> aberto(s) na base local e fechado(s) na Sonax
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="5" class="d-flex justify-end align-center flex-wrap mt-2 mt-md-0">
          <v-btn
            outlined
            small
            color="deep-purple darken-2"
            class="mr-2 text-capitalize font-weight-medium"
            :disabled="elegiveisSonax.length === 0"
            @click="alternarTodosSonax(!todosSelecionadosSonax)"
          >
            <v-icon left small>{{ todosSelecionadosSonax ? 'mdi-checkbox-blank-outline' : 'mdi-checkbox-marked-outline' }}</v-icon>
            {{ todosSelecionadosSonax ? "Desmarcar todos" : `Selecionar elegíveis (${elegiveisSonax.length})` }}
          </v-btn>

          <v-btn
            color="deep-purple darken-1"
            dark
            small
            class="elevation-1 text-capitalize font-weight-bold"
            :disabled="selecionadosSonax.length === 0"
            :loading="fechandoSonax"
            @click="fecharSelecionadosSonax"
          >
            <v-icon left small>mdi-lock-check</v-icon>
            Fechar selecionados na Sonax ({{ selecionadosSonax.length }})
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <!-- Totais por Número da Empresa (Cards & Desempenho) -->
    <v-row class="mb-5">
      <v-col cols="12">
        <v-card class="pa-4 painel-card" elevation="0">
          <div class="d-flex align-center justify-space-between mb-3">
            <div class="d-flex align-center">
              <v-icon color="primary" class="mr-2" size="20">mdi-chart-bar</v-icon>
              <span class="text-subtitle-2 font-weight-bold text--primary">Desempenho por Linha / Número</span>
            </div>
            <v-btn
              small
              outlined
              color="primary"
              class="font-weight-medium"
              :disabled="protocolosVisiveis.length === 0"
              @click="baixarExcel"
            >
              <v-icon left small>mdi-file-excel-outline</v-icon>
              Exportar Relatório Completo
            </v-btn>
          </div>

          <v-simple-table dense class="tabela-desempenho">
            <template #default>
              <thead>
                <tr>
                  <th class="text-left font-weight-bold">Linha / Número da Empresa</th>
                  <th class="text-center font-weight-bold">Abertos</th>
                  <th class="text-center font-weight-bold">Fechados</th>
                  <th v-if="divergenciaConsultada" class="text-center font-weight-bold">Divergências</th>
                  <th class="text-center font-weight-bold">Taxa de Conclusão</th>
                  <th class="text-right font-weight-bold">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="totaisPorNumero.length === 0">
                  <td :colspan="divergenciaConsultada ? 6 : 5" class="grey--text text-center py-4">
                    Nenhum protocolo encontrado no período selecionado
                  </td>
                </tr>
                <tr v-for="linha in totaisPorNumero" :key="linha.numero">
                  <td class="font-weight-medium">
                    <v-icon x-small color="grey" class="mr-1">mdi-phone</v-icon>
                    {{ linha.numero }}
                  </td>
                  <td class="text-center">
                    <v-chip x-small color="amber lighten-4" text-color="amber darken-4" class="font-weight-bold">
                      {{ linha.abertos }}
                    </v-chip>
                  </td>
                  <td class="text-center">
                    <v-chip x-small color="green lighten-4" text-color="green darken-4" class="font-weight-bold">
                      {{ linha.fechados }}
                    </v-chip>
                  </td>
                  <td v-if="divergenciaConsultada" class="text-center">
                    <v-chip
                      v-if="linha.divergencias > 0"
                      x-small
                      color="red lighten-4"
                      text-color="red darken-4"
                      class="font-weight-bold"
                    >
                      {{ linha.divergencias }}
                    </v-chip>
                    <span v-else class="grey--text">—</span>
                  </td>
                  <td class="text-center" style="min-width: 140px;">
                    <div class="d-flex align-center justify-center">
                      <v-progress-linear
                        :value="calcularTaxa(linha.fechados, linha.total)"
                        color="green darken-1"
                        background-color="grey lighten-3"
                        height="6"
                        rounded
                        class="mr-2"
                        style="max-width: 80px;"
                      />
                      <span class="text-caption font-weight-bold">{{ calcularTaxa(linha.fechados, linha.total) }}%</span>
                    </div>
                  </td>
                  <td class="text-right font-weight-bold text-subtitle-2">{{ linha.total }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- Tabela Detalhada de Protocolos -->
    <v-card class="pa-4 painel-card table-card" elevation="0">
      <div class="d-flex flex-column flex-md-row align-start align-md-center justify-space-between mb-4">
        <div>
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-2" size="20">mdi-format-list-bulleted</v-icon>
            <span class="text-subtitle-2 font-weight-bold text--primary">Listagem Detalhada de Protocolos</span>
          </div>
          <span class="text-caption grey--text">
            Exibindo {{ protocolosVisiveis.length }} protocolo(s) conforme os filtros aplicados
          </span>
        </div>

        <div class="d-flex align-center flex-wrap mt-3 mt-md-0">
          <!-- Filtro rápido: Somente Divergências -->
          <div v-if="divergenciaConsultada" class="d-flex align-center mr-3 pa-1 px-2 rounded option-box">
            <v-checkbox
              v-model="somenteDivergencia"
              dense
              hide-details
              color="amber darken-3"
              class="mt-0 pt-0"
            >
              <template #label>
                <span class="text-caption font-weight-bold text--primary">Somente divergências</span>
              </template>
            </v-checkbox>
            <v-tooltip top max-width="320">
              <template #activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  color="grey darken-1"
                  class="ml-1 help-icon"
                >
                  mdi-help-circle-outline
                </v-icon>
              </template>
              <span>esse campo lista somente protocolos divergentes entre as bases do Portal e Sonax Chat</span>
            </v-tooltip>
          </div>

          <!-- Busca rápida por contato -->
          <v-text-field
            v-model="buscaContato"
            dense
            outlined
            hide-details
            clearable
            placeholder="Filtrar contato..."
            prepend-inner-icon="mdi-magnify"
            style="max-width: 220px;"
          />
        </div>
      </div>

      <!-- Data Table -->
      <v-data-table
        :headers="colunas"
        :items="protocolosVisiveis"
        :loading="carregando"
        item-key="protocolo"
        :items-per-page="50"
        sort-by="dataDeAbertura"
        :sort-desc="true"
        :footer-props="rodape"
        class="elevation-0 painel-data-table"
      >
        <!-- Header Checkbox Selecionar Todos -->
        <template #header.selecionar>
          <v-checkbox
            :input-value="todosSelecionados"
            :indeterminate="algunsSelecionados"
            :disabled="elegiveis.length === 0"
            hide-details
            color="error"
            class="mt-0"
            @click.stop
            @change="alternarTodos"
          />
        </template>

        <!-- Coluna Selecionar -->
        <template #item.selecionar="{ item }">
          <v-checkbox
            v-if="item.fechadoSomenteSonax"
            :input-value="estaSelecionado(item)"
            hide-details
            color="error"
            class="mt-0"
            @change="alternarSelecao(item)"
          />
          <v-checkbox
            v-else-if="item.abertoSomenteSonax"
            :input-value="estaSelecionadoSonax(item)"
            hide-details
            color="deep-purple darken-2"
            class="mt-0"
            @change="alternarSelecaoSonax(item)"
          />
        </template>

        <!-- Protocolo -->
        <template #item.protocolo="{ item }">
          <span class="font-weight-bold font-monospace text-body-2 text--primary">
            #{{ item.protocolo }}
          </span>
        </template>

        <!-- Situação -->
        <template #item.status="{ item }">
          <v-chip
            small
            :color="estaFechado(item.status) ? 'green lighten-5' : 'amber lighten-5'"
            :text-color="estaFechado(item.status) ? 'green darken-3' : 'amber darken-4'"
            class="font-weight-medium"
          >
            <v-icon left x-small :color="estaFechado(item.status) ? 'green darken-3' : 'amber darken-4'">
              {{ estaFechado(item.status) ? 'mdi-check-circle' : 'mdi-clock-outline' }}
            </v-icon>
            {{ rotuloSituacao(item.status) }}
          </v-chip>
        </template>

        <!-- Número da Empresa -->
        <template #item.numeroEmpresa="{ item }">
          <span class="text-body-2">{{ item.numeroEmpresa || "—" }}</span>
        </template>

        <!-- Contato -->
        <template #item.numeroDoContato="{ item }">
          <div class="d-flex align-center">
            <v-icon x-small color="grey" class="mr-1">mdi-account-outline</v-icon>
            <span class="font-weight-medium text-body-2">{{ item.numeroDoContato || "—" }}</span>
          </div>
        </template>

        <!-- Abertura -->
        <template #item.dataDeAbertura="{ item }">
          <div class="d-flex flex-column">
            <span class="text-body-2 font-weight-medium">{{ item.dataDeAbertura || "—" }}</span>
            <span v-if="item.horaDeAbertura" class="text-caption grey--text">{{ item.horaDeAbertura }}</span>
          </div>
        </template>

        <!-- Interação -->
        <template #item.interacaoCliente="{ item }">
          <v-chip
            v-if="item.interacaoCliente"
            small
            color="cyan lighten-5"
            text-color="cyan darken-4"
            class="font-weight-medium"
          >
            <v-icon left x-small color="cyan darken-4">mdi-message-reply-text</v-icon>
            Com interação
          </v-chip>
          <v-chip v-else small outlined color="grey" class="font-weight-regular">
            Sem interação
          </v-chip>
        </template>

        <!-- Divergência -->
        <template #item.divergencia="{ item }">
          <v-chip
            v-if="item.fechadoSomenteSonax"
            small
            color="amber lighten-4"
            text-color="amber darken-4"
            class="font-weight-bold"
          >
            <v-icon left x-small color="amber darken-4">mdi-alert</v-icon>
            Aberto Local · Fechado Sonax
          </v-chip>
          <v-chip
            v-else-if="item.abertoSomenteSonax"
            small
            color="deep-purple lighten-4"
            text-color="deep-purple darken-4"
            class="font-weight-bold"
          >
            <v-icon left x-small color="deep-purple darken-4">mdi-alert-octagon</v-icon>
            Fechado Local · Aberto Sonax
          </v-chip>
          <span v-else class="grey--text">—</span>
        </template>

        <!-- Empty State -->
        <template #no-data>
          <div class="pa-8 text-center">
            <v-icon size="48" color="grey lighten-1" class="mb-2">mdi-chat-processing-outline</v-icon>
            <div class="text-subtitle-1 font-weight-medium grey--text text--darken-1">
              Nenhum protocolo localizado
            </div>
            <div class="text-caption grey--text">
              Ajuste o período, filtros ou selecione outra empresa para visualizar os dados.
            </div>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- Snackbar de Notificações -->
    <v-snackbar v-model="snackbar" :color="snackbarCor" timeout="4000" top right>
      <div class="d-flex align-center">
        <v-icon left color="white">
          {{ snackbarCor === 'error' ? 'mdi-alert-circle' : snackbarCor === 'warning' ? 'mdi-alert' : 'mdi-check-circle' }}
        </v-icon>
        <span>{{ snackbarTexto }}</span>
      </div>
    </v-snackbar>
  </v-container>
</template>

<script>
import * as XLSX from "xlsx";
import sonax from "@/services/v2sonax";

const TELEFONES_EMPRESA = {
  PREVIDA: "558282308177",
  "MEMORIAL PARQUE MACEIÓ": "558299289412",
  "PARQUE DAS FLORES": "558296411028",
  "CEMITERIO PREVIDA": "558000829000",
  "CEMITERIO PREVIDA SÃO MIGUEL": "558000829000",
  "PARQUE DO AGRESTE": "558000829000",
  "A FLOR DO CAFÉ": "558282308177",
};

export default {
  name: "PainelChat",
  data() {
    const hoje = new Date().toISOString().slice(0, 10);
    return {
      dataInicio: hoje,
      dataFim: hoje,
      menuInicio: false,
      menuFim: false,
      periodoSelecionado: "hoje",
      periodosRapidos: [
        { texto: "Hoje", valor: "hoje" },
        { texto: "Ontem", valor: "ontem" },
        { texto: "Últimos 7 dias", valor: "7dias" },
        { texto: "Este Mês", valor: "mes" },
      ],
      empresa: "PREVIDA",
      protocolo: "",
      situacao: "todos",
      situacoes: [
        { text: "Todos os status", value: "todos" },
        { text: "Apenas Abertos", value: "abertos" },
        { text: "Apenas Fechados", value: "fechados" },
      ],
      interacao: "todos",
      opcoesInteracao: [
        { text: "Todas as interações", value: "todos" },
        { text: "Com interação do cliente", value: "com" },
        { text: "Sem interação do cliente", value: "sem" },
      ],
      consultarDivergencia: false,
      ignorarCampanha: true,
      divergenciaConsultada: false,
      interacaoCalculada: false,
      empresas: Object.keys(TELEFONES_EMPRESA),
      buscaContato: "",
      somenteDivergencia: false,
      protocolos: [],
      selecionados: [],
      selecionadosSonax: [],
      carregando: false,
      fechando: false,
      fechandoSonax: false,
      snackbar: false,
      snackbarTexto: "",
      snackbarCor: "success",
      rodape: {
        "items-per-page-options": [50, 100, 200],
        "items-per-page-text": "Protocolos por página",
      },
      headers: [
        { text: "", value: "selecionar", sortable: false, width: 48 },
        { text: "Protocolo", value: "protocolo", width: 140 },
        { text: "Situação", value: "status", width: 130 },
        { text: "Número da Empresa", value: "numeroEmpresa", width: 170 },
        { text: "Contato / Cliente", value: "numeroDoContato", width: 180 },
        { text: "Abertura", value: "dataDeAbertura", width: 160 },
        { text: "Interação", value: "interacaoCliente", width: 160 },
        { text: "Divergência Sonax", value: "divergencia", sortable: false, width: 230 },
      ],
    };
  },
  computed: {
    colunas() {
      return this.headers.filter((coluna) => {
        if (!this.divergenciaConsultada && (coluna.value === "divergencia" || coluna.value === "selecionar")) {
          return false;
        }
        if (!this.interacaoCalculada && coluna.value === "interacaoCliente") return false;
        return true;
      });
    },
    protocolosVisiveis() {
      const contato = String(this.buscaContato || "").replace(/\D/g, "");
      return this.protocolos.filter((item) => {
        if (this.situacao === "abertos" && this.estaFechado(item.status)) return false;
        if (this.situacao === "fechados" && !this.estaFechado(item.status)) return false;
        if (contato) {
          const numero = String(item.numeroDoContato || "").replace(/\D/g, "");
          if (!numero.includes(contato)) return false;
        }
        if (
          this.divergenciaConsultada &&
          this.somenteDivergencia &&
          !item.fechadoSomenteSonax &&
          !item.abertoSomenteSonax
        ) {
          return false;
        }
        return true;
      });
    },
    elegiveis() {
      return this.protocolosVisiveis.filter((item) => item.fechadoSomenteSonax);
    },
    elegiveisSonax() {
      return this.protocolosVisiveis.filter((item) => item.abertoSomenteSonax);
    },
    todosSelecionados() {
      return this.elegiveis.length > 0 && this.elegiveis.every((item) => this.selecionados.includes(item.protocolo));
    },
    todosSelecionadosSonax() {
      return (
        this.elegiveisSonax.length > 0 &&
        this.elegiveisSonax.every((item) => this.selecionadosSonax.includes(item.protocolo))
      );
    },
    algunsSelecionados() {
      const marcados = this.elegiveis.filter((item) => this.selecionados.includes(item.protocolo)).length;
      return marcados > 0 && marcados < this.elegiveis.length;
    },
    divergentesFechadosSonax() {
      return this.protocolosVisiveis.filter((item) => item.fechadoSomenteSonax).length;
    },
    divergentesAbertosSonax() {
      return this.protocolosVisiveis.filter((item) => item.abertoSomenteSonax).length;
    },
    totais() {
      const lista = this.protocolosVisiveis;
      const fechados = lista.filter((item) => this.estaFechado(item.status)).length;
      const divergencias = lista.filter(
        (item) => item.fechadoSomenteSonax || item.abertoSomenteSonax,
      ).length;
      const comInteracao = lista.filter((item) => item.interacaoCliente).length;
      return {
        total: lista.length,
        abertos: lista.length - fechados,
        fechados,
        divergencias,
        comInteracao,
      };
    },
    taxaResolucao() {
      if (!this.totais.total) return 0;
      return Math.round((this.totais.fechados / this.totais.total) * 100);
    },
    taxaAbertos() {
      if (!this.totais.total) return 0;
      return Math.round((this.totais.abertos / this.totais.total) * 100);
    },
    taxaInteracao() {
      if (!this.totais.total) return 0;
      return Math.round((this.totais.comInteracao / this.totais.total) * 100);
    },
    totaisPorNumero() {
      const mapa = {};
      this.protocolosVisiveis.forEach((item) => {
        const numero = item.numeroEmpresa || "—";
        if (!mapa[numero]) {
          mapa[numero] = { numero, abertos: 0, fechados: 0, divergencias: 0, total: 0 };
        }
        mapa[numero].total += 1;
        if (this.estaFechado(item.status)) mapa[numero].fechados += 1;
        else mapa[numero].abertos += 1;
        if (item.fechadoSomenteSonax || item.abertoSomenteSonax) mapa[numero].divergencias += 1;
      });
      return Object.values(mapa).sort((a, b) => b.total - a.total);
    },
  },
  methods: {
    formatarData(iso) {
      if (!iso) return "";
      const [ano, mes, dia] = iso.split("-");
      return `${dia}/${mes}/${ano}`;
    },
    aplicarPeriodoRapido(tipo) {
      this.periodoSelecionado = tipo;
      const hojeObj = new Date();
      const formatarISO = (d) => d.toISOString().slice(0, 10);

      if (tipo === "hoje") {
        this.dataInicio = formatarISO(hojeObj);
        this.dataFim = formatarISO(hojeObj);
      } else if (tipo === "ontem") {
        const ontem = new Date();
        ontem.setDate(ontem.getDate() - 1);
        this.dataInicio = formatarISO(ontem);
        this.dataFim = formatarISO(ontem);
      } else if (tipo === "7dias") {
        const seteDias = new Date();
        seteDias.setDate(seteDias.getDate() - 6);
        this.dataInicio = formatarISO(seteDias);
        this.dataFim = formatarISO(hojeObj);
      } else if (tipo === "mes") {
        const primeiroDia = new Date(hojeObj.getFullYear(), hojeObj.getMonth(), 1);
        this.dataInicio = formatarISO(primeiroDia);
        this.dataFim = formatarISO(hojeObj);
      }
    },
    calcularTaxa(valor, total) {
      if (!total) return 0;
      return Math.round((valor / total) * 100);
    },
    periodoValido() {
      if (!this.dataInicio || !this.dataFim || this.dataFim < this.dataInicio) return false;
      const inicio = new Date(`${this.dataInicio}T00:00:00`);
      const fim = new Date(`${this.dataFim}T00:00:00`);
      const dias = Math.round((fim - inicio) / 86400000) + 1;
      return dias >= 1 && dias <= 31;
    },
    estaFechado(status) {
      const valor = String(status || "").toLowerCase();
      return valor === "closed" || valor === "fechado" || valor === "close";
    },
    rotuloSituacao(status) {
      if (!status) return "—";
      if (this.estaFechado(status)) return "Fechado";
      if (String(status).toLowerCase() === "open") return "Aberto";
      return status;
    },
    rotuloDivergencia(item) {
      if (item.fechadoSomenteSonax) return "Aberto local / Fechado Sonax";
      if (item.abertoSomenteSonax) return "Fechado local / Aberto Sonax";
      return "";
    },
    estaSelecionado(item) {
      return this.selecionados.includes(item.protocolo);
    },
    estaSelecionadoSonax(item) {
      return this.selecionadosSonax.includes(item.protocolo);
    },
    alternarSelecao(item) {
      if (!item.fechadoSomenteSonax) return;
      if (this.estaSelecionado(item)) {
        this.selecionados = this.selecionados.filter((numero) => numero !== item.protocolo);
      } else {
        this.selecionados = this.selecionados.concat(item.protocolo);
      }
    },
    alternarSelecaoSonax(item) {
      if (!item.abertoSomenteSonax) return;
      if (this.estaSelecionadoSonax(item)) {
        this.selecionadosSonax = this.selecionadosSonax.filter((numero) => numero !== item.protocolo);
      } else {
        this.selecionadosSonax = this.selecionadosSonax.concat(item.protocolo);
      }
    },
    alternarTodos(marcar) {
      const numeros = this.elegiveis.map((item) => item.protocolo);
      if (marcar) {
        this.selecionados = Array.from(new Set(this.selecionados.concat(numeros)));
      } else {
        this.selecionados = this.selecionados.filter((numero) => !numeros.includes(numero));
      }
    },
    alternarTodosSonax(marcar) {
      const numeros = this.elegiveisSonax.map((item) => item.protocolo);
      if (marcar) {
        this.selecionadosSonax = Array.from(new Set(this.selecionadosSonax.concat(numeros)));
      } else {
        this.selecionadosSonax = this.selecionadosSonax.filter((numero) => !numeros.includes(numero));
      }
    },
    async buscar() {
      if (!this.empresa || !this.dataInicio || !this.dataFim) {
        this.avisar("Informe empresa e período", "error");
        return;
      }
      if (!this.periodoValido()) {
        this.avisar("O período máximo é de 31 dias", "error");
        return;
      }
      this.carregando = true;
      this.selecionados = [];
      this.selecionadosSonax = [];
      try {
        const telefone = TELEFONES_EMPRESA[this.empresa] || "558282308177";
        const response = await sonax.listarPainelProtocolos(
          this.dataInicio,
          this.dataFim,
          this.empresa,
          telefone,
          this.protocolo || undefined,
          {
            consultarDivergencia: this.consultarDivergencia,
            interacao: this.interacao,
            ignorarCampanha: this.ignorarCampanha,
          },
        );
        const body = response.data || {};
        this.protocolos = body.data || [];
        this.divergenciaConsultada = this.consultarDivergencia;
        this.interacaoCalculada = true;
        if (body.message && String(body.message).includes("indisponível")) {
          this.avisar(body.message, "warning");
        }
      } catch (error) {
        this.protocolos = [];
        this.divergenciaConsultada = false;
        this.interacaoCalculada = false;
        this.avisar("Não foi possível carregar os protocolos", "error");
      } finally {
        this.carregando = false;
      }
    },
    async fecharSelecionados() {
      if (this.selecionados.length === 0) return;
      this.fechando = true;
      try {
        const response = await sonax.fecharProtocolosLocal(this.selecionados);
        const fechados = response.data && response.data.fechados ? response.data.fechados : 0;
        this.avisar(`${fechados} protocolo(s) fechado(s) na base local`, "success");
        await this.buscar();
      } catch (error) {
        this.avisar("Não foi possível fechar os protocolos na base", "error");
      } finally {
        this.fechando = false;
      }
    },
    async fecharSelecionadosSonax() {
      if (this.selecionadosSonax.length === 0) return;
      this.fechandoSonax = true;
      try {
        const response = await sonax.fecharProtocolosSonax(this.selecionadosSonax);
        const fechados = response.data && response.data.fechados ? response.data.fechados : 0;
        this.avisar(`${fechados} protocolo(s) fechado(s) na Sonax`, "success");
        await this.buscar();
      } catch (error) {
        this.avisar("Não foi possível fechar os protocolos na Sonax", "error");
      } finally {
        this.fechandoSonax = false;
      }
    },
    baixarExcel() {
      const linhas = this.protocolosVisiveis.map((item) => ({
        Protocolo: item.protocolo,
        Situação: this.rotuloSituacao(item.status),
        "Número da empresa": item.numeroEmpresa || "",
        Contato: item.numeroDoContato || "",
        Abertura: item.dataDeAbertura || "",
        Hora: item.horaDeAbertura || "",
        Interação: this.interacaoCalculada ? (item.interacaoCliente ? "Com interação" : "Sem interação") : "",
        Divergência: this.divergenciaConsultada ? this.rotuloDivergencia(item) : "",
        Cliente: item.clienteNome || "",
        Origem: item.origem || "",
        "Em atendimento": item.emAtendimento || "",
      }));
      const planilha = XLSX.utils.json_to_sheet(linhas);
      const pasta = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(pasta, planilha, "Painel");
      XLSX.writeFile(pasta, `painel_protocolos_${Date.now()}.xlsx`);
    },
    avisar(texto, cor) {
      this.snackbarTexto = texto;
      this.snackbarCor = cor;
      this.snackbar = true;
    },
  },
};
</script>

<style scoped>
.painel-chat-container {
  background-color: #f8f9fb;
  min-height: calc(100vh - 64px);
}

.painel-card {
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
}

.kpi-card {
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.kpi-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06) !important;
}

.divergencia-alerta {
  border-color: #fca5a5 !important;
  background: linear-gradient(180deg, #fff 0%, #fef2f2 100%) !important;
}

.divergencia-banner {
  background: linear-gradient(90deg, #fffbeb 0%, #ffffff 100%) !important;
  border-color: #fcd34d !important;
  border-left: 4px solid #f59e0b !important;
}

.divergencia-sonax-banner {
  background: linear-gradient(90deg, #f5f3ff 0%, #ffffff 100%) !important;
  border-color: #c4b5fd !important;
  border-left: 4px solid #7c3aed !important;
}

.option-box {
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  width: 100%;
}

.help-icon {
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.help-icon:hover {
  opacity: 1;
}

.tabela-desempenho th {
  color: #64748b !important;
  font-size: 0.75rem !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background-color: #f8fafc;
}

.tabela-desempenho td {
  border-bottom: 1px solid #f1f5f9 !important;
}

.painel-data-table >>> th {
  color: #64748b !important;
  font-size: 0.75rem !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background-color: #f8fafc;
}

.font-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  letter-spacing: 0.02em;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
